import { render, staticRenderFns } from "./CreateReturnSelectParts.vue?vue&type=template&id=263bbda1"
import script from "./CreateReturnSelectParts.vue?vue&type=script&lang=js"
export * from "./CreateReturnSelectParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports